import { ObjectRule } from '@/classes/rules/ObjectRule';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { InjectionModelRef } from '@/dto/scenario/ScenarioReference';
import { ProjectTypeRef } from '@/dto/scenario/ProjectReference';
import { ScenarioOpexExt } from '@/classes/scenario/ren-fr/opex/ScenarioOpexExt';
import { MinMaxRule } from '@/classes/rules/MinMaxRule';

export const buildOpexRules = () => new ObjectRule<ScenarioOpexExt>('opex', [
  new MinMaxRule('actualAdministrativeManagementCost'),

  new MinMaxRule('leaseArea'),

  new MinMaxRule('fixedAnnualRentPeriod1'),
  new MinMaxRule('fixedNumberOfYearsPeriod1'),

  new MinMaxRule('variableAnnualRentPeriod1'),
  new MinMaxRule('variableNumberOfYearsPeriod1'),

  new MinMaxRule('purchasePriceOfLand'),
  new MinMaxRule('upfrontRentPayment'),

  new MinMaxRule('omContractWithMargin'),
  new MinMaxRule('omContractWithoutMargin'),
  new MinMaxRule('verifications'),
  new MinMaxRule('networkMeterDeie'),
  new MinMaxRule('electricity'),
  new MinMaxRule('telecom'),
  new MinMaxRule('maintenanceRepairsForRealEstateEquipmentWorks'),

  new MinMaxRule('environmentalChargesYear1'),
  new MinMaxRule('environmentalChargesYear2'),
  new MinMaxRule('environmentalChargesYear3'),
  new MinMaxRule('environmentalChargesYear4'),
  new MinMaxRule('environmentalChargesYear5'),
  new MinMaxRule('environmentalChargesYear6'),
  new MinMaxRule('environmentalChargesYear7'),
  new MinMaxRule('environmentalChargesYear8'),
  new MinMaxRule('environmentalChargesYear9'),
  new MinMaxRule('environmentalChargesYear10'),
  new MinMaxRule('environmentalChargesYear11'),
  new MinMaxRule('environmentalChargesYear12'),
  new MinMaxRule('environmentalChargesYear13'),
  new MinMaxRule('environmentalChargesYear14'),
  new MinMaxRule('environmentalChargesYear15'),
  new MinMaxRule('environmentalChargesYear16'),
  new MinMaxRule('environmentalChargesYear17'),
  new MinMaxRule('environmentalChargesYear18'),
  new MinMaxRule('environmentalChargesYear19'),
  new MinMaxRule('environmentalChargesYear20'),
  new MinMaxRule('environmentalChargesYear21'),
  new MinMaxRule('environmentalChargesYear22'),
  new MinMaxRule('environmentalChargesYear23'),
  new MinMaxRule('environmentalChargesYear24'),
  new MinMaxRule('environmentalChargesYear25'),
  new MinMaxRule('environmentalChargesYear26'),
  new MinMaxRule('environmentalChargesYear27'),
  new MinMaxRule('environmentalChargesYear28'),
  new MinMaxRule('environmentalChargesYear29'),
  new MinMaxRule('environmentalChargesYear30'),
  new MinMaxRule('environmentalChargesYear31'),
  new MinMaxRule('environmentalChargesYear32'),
  new MinMaxRule('environmentalChargesYear33'),
  new MinMaxRule('environmentalChargesYear34'),
  new MinMaxRule('environmentalChargesYear35'),

  new MinMaxRule('otherChargesYear1'),
  new MinMaxRule('otherChargesYear2'),
  new MinMaxRule('otherChargesYear3'),
  new MinMaxRule('otherChargesYear4'),
  new MinMaxRule('otherChargesYear5'),
  new MinMaxRule('otherChargesYear6'),
  new MinMaxRule('otherChargesYear7'),
  new MinMaxRule('otherChargesYear8'),
  new MinMaxRule('otherChargesYear9'),
  new MinMaxRule('otherChargesYear10'),
  new MinMaxRule('otherChargesYear11'),
  new MinMaxRule('otherChargesYear12'),
  new MinMaxRule('otherChargesYear13'),
  new MinMaxRule('otherChargesYear14'),
  new MinMaxRule('otherChargesYear15'),
  new MinMaxRule('otherChargesYear16'),
  new MinMaxRule('otherChargesYear17'),
  new MinMaxRule('otherChargesYear18'),
  new MinMaxRule('otherChargesYear19'),
  new MinMaxRule('otherChargesYear20'),
  new MinMaxRule('otherChargesYear21'),
  new MinMaxRule('otherChargesYear22'),
  new MinMaxRule('otherChargesYear23'),
  new MinMaxRule('otherChargesYear24'),
  new MinMaxRule('otherChargesYear25'),
  new MinMaxRule('otherChargesYear26'),
  new MinMaxRule('otherChargesYear27'),
  new MinMaxRule('otherChargesYear28'),
  new MinMaxRule('otherChargesYear29'),
  new MinMaxRule('otherChargesYear30'),
  new MinMaxRule('otherChargesYear31'),
  new MinMaxRule('otherChargesYear32'),
  new MinMaxRule('otherChargesYear33'),
  new MinMaxRule('otherChargesYear34'),
  new MinMaxRule('otherChargesYear35'),

  new MinMaxRule('omTurbineDurationPeriod1')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineDurationPeriod2')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineDurationPeriod3')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineDurationPeriod4')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineDurationPeriod5')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineDurationPeriod6')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),

  new MinMaxRule('omTurbineFixedPricePeriod1')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineFixedPricePeriod2')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineFixedPricePeriod3')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineFixedPricePeriod4')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineFixedPricePeriod5')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineFixedPricePeriod6')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),

  new MinMaxRule('omTurbineVariablePricePeriod1')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineVariablePricePeriod2')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineVariablePricePeriod3')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineVariablePricePeriod4')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineVariablePricePeriod5')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineVariablePricePeriod6')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),

  new MinMaxRule('omTurbineMinimumVariablePricePeriod1')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineMinimumVariablePricePeriod2')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineMinimumVariablePricePeriod3')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineMinimumVariablePricePeriod4')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineMinimumVariablePricePeriod5')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),
  new MinMaxRule('omTurbineMinimumVariablePricePeriod6')
    .withIsAvailable(scenario => isRenFranceWindProject(scenario)),

  new MinMaxRule('municipalRate'),
  new MinMaxRule('departmentalRate'),

  new MinMaxRule('municipalRateCFE'),
  new MinMaxRule('interMunicipalRateCFE'),
  new MinMaxRule('coefficientDeNeutralisationCFE'),

  new MinMaxRule('municipalRatePropertyTax'),
  new MinMaxRule('interMunicipalRatePropertyTax'),
  new MinMaxRule('coefficientDeNeutralisationTF'),

  new MinMaxRule('environmentalCharges')

])
  .withIsAvailable(scenario => isRenFranceProject(scenario))
  .withDefaultValue(() => new DefaultValue(new ScenarioOpexExt()));

function isRenFranceProject(scenario: ScenarioExt): boolean {
  return (scenario.project?.typeRef === ProjectTypeRef.ren_fr_pv_project || scenario.project?.typeRef === ProjectTypeRef.ren_fr_wind_project) &&
    scenario.hasInjectionType(InjectionModelRef.total_injection);
}

function isRenFranceWindProject(scenario: ScenarioExt): boolean {
  return scenario.project?.typeRef === ProjectTypeRef.ren_fr_wind_project;
}
